import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2, Download, Server } from "lucide-react";
import { Button } from "@/components/ui/button";
import { QuoteSheet } from "@/components/QuoteSheet";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicQuote() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/public/quotes/${id}`);
      setData(res.data);
      if (res.data.has_logo) {
        try {
          const l = await axios.get(`${API}/public/quotes/${id}/logo`, { responseType: "blob" });
          setLogoUrl(URL.createObjectURL(l.data));
        } catch (e) {
          console.error("Public logo load error:", e);
        }
      }
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  const download = async () => {
    const res = await axios.get(`${API}/public/quotes/${id}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Presupuesto_${data.number}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-100"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  }
  if (error || !data) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-100 gap-2 px-6 text-center">
        <p className="font-display text-xl font-bold">Presupuesto no disponible</p>
        <p className="text-muted-foreground text-sm">El enlace no es válido o el presupuesto ha sido eliminado.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100">
      <header className="bg-[#0b1a3a] text-white">
        <div className="max-w-[760px] mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-md bg-primary flex items-center justify-center">
              <Server className="h-4 w-4 text-white" />
            </div>
            <span className="font-display font-bold tracking-tight">{data.company?.company_name || "JDMTECH"}</span>
          </div>
          <Button onClick={download} data-testid="public-download" size="sm">
            <Download className="h-4 w-4 mr-1.5" /> Descargar PDF
          </Button>
        </div>
      </header>
      <main className="py-6 px-3">
        <QuoteSheet quote={data} client={data.client} settings={data.company || {}} logoUrl={logoUrl} />
        <div className="max-w-[720px] mx-auto mt-4 flex justify-center pb-10">
          <Button onClick={download} data-testid="public-download-bottom">
            <Download className="h-4 w-4 mr-1.5" /> Descargar PDF
          </Button>
        </div>
      </main>
    </div>
  );
}
